import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Register } from '@app/_models/register';
import { StringMap } from '@angular/compiler/src/compiler_facade_interface';
import { BehaviorSubject, Observable ,of} from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { headervalue } from 'src/headervalue/header';

const httpOptions = {
    // headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    headers: new HttpHeaders(headervalue.headerWithJwt)
  };

@Injectable({ providedIn: 'root' })

export class RegisterService {
    constructor(private http: HttpClient) { }

addRegister(RegisterParam: Register): Observable<Register> {
    // return this.http.post<Register>(`${environment.apiUrl}/auth/studentSignUp`,RegisterParam, httpOptions).pipe(
    // //   tap((onDemandSettingsParam: Register) => this.log('saved onDemandSettingsParam')),
    // //   catchError(this.handleError<Register>('addSettings'))
    // );
    
    return this.http.post<Register>(`${environment.apiUrl}/auth/studentSignUp`,RegisterParam, httpOptions).pipe(
            //return this.http.get<boolean>(`${environment.apiUrl}/auth/signin`+ '/' + username+ '/' + password )
            );
  }

    // registrationSave(userid: number, contactPersonName: string,emailid  :string, password :String, mobilenumber :String,
    //     verificationStatus :string,companyname :string,universityid :number) {
    //    return this.http.post<any>(`${environment.apiUrl}/auth/studentSignUp`, { userid, contactPersonName,emailid,password,mobilenumber,verificationStatus,companyname,universityid })
    //           .pipe(map(regis => {
    //             //  store user details and basic auth credentials in local storage to keep user logged in between page refreshes
    //             //  user.authdata = window.btoa(username + ':' + password);
    //             //  //user.authdata = window.btoa(username );
    //             //  localStorage.setItem('currentUser', JSON.stringify(user));
    //             //  localStorage.setItem('currentRole', JSON.stringify(user.role));
    //             //  localStorage.setItem('token', JSON.stringify(user.token));
    //             //  this.currentUserSubject.next(user);
    //              return regis;
    //          }));      
    //  }

     private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
    
          //  this.errorparam = this.onDemandSettingsParam.Error;
          //console.warn("HI Ashwini");
          console.log(error);
          // TODO: send the error to remote logging infrastructure
          // console.error(error); // log to console instead
    
          // TODO: better job of transforming error for user consumption
          //this.log(`${operation} failed: ${error.message}`);
    
          // Let the app keep running by returning an empty result.
          return of(result as T);
        };
      }

}